<template>
  <div class="organization-hierarchy-wrapper card">
    <page-header
      title="Organization Hierachy"
      breadcrumb="Dashboard >> Settings >> Organization Hierarchy"
    />
    <div class="my-3">
      <p class="font-semibold text-primary-yellow">Your Organization Structure</p>
      <p class="text-sm mt-2">
        This diagram displays the hierarchy of Designations within your
        organization. Added people show up in the tree, according to their
        hierarchy, job level, function and designtion.
      </p>
    </div>

    <div class="org-structure" v-if="organizationStructure">
      <organization-chart
        :datasource="organizationStructure"
      ></organization-chart>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import OrganizationChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";

export default {
  components: {
    PageHeader,
    OrganizationChart,
  },
  data() {
    return {
      organizationStructure: null,
    };
  },
  mounted() {
    this.getOrganizationStructure();
  },
  methods: {
    async getOrganizationStructure() {
      try {
        let response = await this.$_getOrganizationStructure();
        console.log(response);
        this.organizationStructure = response.data.orgStructure[0];
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style>
.orgchart-container {
  border: none;
  width: 100% !important;
  overflow: none !important;
}
.orgchart {
  background-image: initial;
}
.node {
  border: 1px solid grey !important;
  padding: 20px !important;
}
.node:hover {
  background: #edf2f7 !important;
}
.node > .title {
  background: transparent !important;
  color: black !important;
  font-size: 10px !important;
}
.node > .content {
  border: none !important;
  background: transparent !important;
  color: black !important;
  display: none !important;
}
.orgchart table {
  border-spacing: 0 !important;
  border-collapse: separate !important;
}

.orgchart .node {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  margin: 0px 4px;
  padding: 3px !important;
  border: 2px dashed transparent !important;
  text-align: center;
  width: 100px;
  background: #f6f6f6;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 8px;
  border-radius: 3px;
}
.orgchart .lines:nth-child(3) td {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 40px;
}
.orgchart .lines .rightLine {
  border-right: 1px solid grey;
  float: none;
  border-radius: 0;
}
.orgchart table {
  border-spacing: 0 !important;
  border-collapse: separate !important;
}
.orgchart .lines .downLine {
  background-color: grey;
  margin: 0 auto;
  height: 40px;
  width: 2px;
  float: none;
}
.orgchart td {
  text-align: center;
  vertical-align: top;
  padding: 0;
}

.orgchart-container {
  position: relative;
  display: inline-block;
  width: calc(100% - 24px);
  border-radius: 5px;
  text-align: center;
}

.orgchart.r2l {
  position: absolute;
  transform: rotate(90deg);
  transform-origin: left top;
}
.orgchart > .spinner {
  font-size: 100px;
  margin-top: 30px;
  color: rgba(68, 157, 68, 0.8);
}
.orgchart table {
  border-spacing: 0;
  border-collapse: separate;
}
.orgchart > table:first-child {
  /* margin: 20px auto; */
  margin: 40px auto;
}
.orgchart td {
  text-align: center;
  vertical-align: top;
  padding: 0;
}
.orgchart .lines:nth-child(3) td {
  box-sizing: border-box;
  height: 40px;
}
.orgchart .lines .topLine {
  /* border-top: 2px solid rgba(217, 83, 79, 0.8); */
  border-top: 1px solid grey;
}
.orgchart .lines .rightLine {
  /* border-right: 1px solid rgba(217, 83, 79, 0.8); */
  border-right: 1px solid grey;
  float: none;
  border-radius: 0;
}
.orgchart .lines .leftLine {
  /* border-left: 1px solid rgba(217, 83, 79, 0.8); */
  border-left: 1px solid grey;
  float: none;
  border-radius: 0;
}
.orgchart .lines .downLine {
  /* background-color: rgba(217, 83, 79, 0.8); */
  background-color: grey;
  margin: 0 auto;
  /* height: 20px; */
  height: 40px;
  width: 2px;
  float: none;
}
/* node styling */
.orgchart .node {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  margin: 4px;
  padding: 3px;
  border: 2px dashed transparent;
  text-align: center;
  /* width: 130px; */
  width: 100px;
}
.orgchart .node .edge {
  font-size: 15px;
  position: absolute;
  color: rgba(68, 157, 68, 0.5);
  cursor: default;
  transition: 0.2s;
}
.orgchart.noncollapsable .node .edge {
  display: none;
}
.orgchart .edge:hover {
  color: #449d44;
  cursor: pointer;
}
.orgchart .node .verticalEdge {
  width: calc(100% - 10px);
  width: -webkit-calc(100% - 10px);
  width: -moz-calc(100% - 10px);
  left: 5px;
}
.orgchart .node .topEdge {
  top: -4px;
}
.orgchart .node .bottomEdge {
  bottom: -4px;
}
.orgchart .node .horizontalEdge {
  width: 15px;
  height: calc(100% - 10px);
  height: -webkit-calc(100% - 10px);
  height: -moz-calc(100% - 10px);
  top: 5px;
}
.orgchart .node .rightEdge {
  right: -4px;
}
.orgchart .node .leftEdge {
  left: -4px;
}
.orgchart .node .horizontalEdge::before {
  position: absolute;
  top: calc(50% - 7px);
}
.orgchart .node .rightEdge::before {
  right: 3px;
}
.orgchart .node .leftEdge::before {
  left: 3px;
}
.orgchart .node .toggleBtn {
  position: absolute;
  left: 5px;
  bottom: -2px;
  color: rgba(68, 157, 68, 0.6);
}
.orgchart .node .toggleBtn:hover {
  color: rgba(68, 157, 68, 0.8);
}
.oc-export-btn {
  display: inline-block;
  position: absolute;
  right: 5px;
  top: 5px;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  user-select: none;
  color: #fff;
  background-color: #5cb85c;
  border: 1px solid transparent;
  border-color: #4cae4c;
  border-radius: 4px;
}
.oc-export-btn[disabled] {
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.3;
}
.oc-export-btn:hover,
.oc-export-btn:focus,
.oc-export-btn:active {
  background-color: #449d44;
  border-color: #347a34;
}
.orgchart ~ .mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
}
.orgchart ~ .mask .spinner {
  position: absolute;
  top: calc(50% - 54px);
  left: calc(50% - 54px);
  color: rgba(255, 255, 255, 0.8);
  font-size: 108px;
}
.orgchart .node {
  transition: transform 0.3s, opacity 0.3s;
}
.orgchart .slide-down {
  opacity: 0;
  transform: translateY(40px);
}
.orgchart.l2r .node.slide-down,
.orgchart.r2l .node.slide-down {
  transform: translateY(130px);
}
.orgchart .slide-up {
  opacity: 0;
  transform: translateY(-40px);
}
.orgchart.l2r .node.slide-up,
.orgchart.r2l .node.slide-up {
  transform: translateY(-130px);
}
.orgchart .slide-right {
  opacity: 0;
  transform: translateX(130px);
}
.orgchart.l2r .node.slide-right,
.orgchart.r2l .node.slide-right {
  transform: translateX(40px);
}
.orgchart .slide-left {
  opacity: 0;
  transform: translateX(-130px);
}
.orgchart.l2r .node.slide-left,
.orgchart.r2l .node.slide-left {
  transform: translateX(-40px);
}
</style>
